import { useEffect, useState } from 'react';
import { GetCustomerResponse } from '@/ar/network/AccountsReceivable.network';

interface Option {
    value: string,
    label: string,
}

export const useEmailOptions = (customer? :GetCustomerResponse) => {
    const [allOptions, setAllOptions] = useState<Option[]>([]);
    const [defaultOptions, setDefaultOptions] = useState<Option[]>([]);
    const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
    useEffect(() => {
        let existingEmails: string [] = [];
        if (customer?.email) {
            const customerEmail = customer.email.toLowerCase().trim();
            setSelectedEmails([customerEmail]);
            setDefaultOptions([{ value: customerEmail, label: customerEmail }]);
            existingEmails.push(customerEmail);
        } else {
            setSelectedEmails([]);
            setDefaultOptions([]);
        }
        if (customer?.cc_emails) {
            existingEmails = Array.from(
                new Set([
                    ...existingEmails,
                    ...customer.cc_emails
                        .map((email) => email.toLowerCase().trim())
                ])
            );
        }

        const all: Option[] = existingEmails.map((email) => ({ value: email, label: email }));
        if (all.length > 0) {
            setAllOptions(all);
        } else {
            setAllOptions([]);
        }
    }, [customer, customer?.email, customer?.cc_emails]);
    return { allOptions, defaultOptions, selectedEmails, setSelectedEmails };
};
